import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { TdDialogService } from '@covalent/core';
import { Applicant } from '../../../shared/models/applicant.model';
import { currentUser, PortalUser } from '../../../shared/models/portal-user.model';
import { BaseComponent } from '../../../shared/components/base.component';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationTypesService } from '../../../shared/services/application-types.service';
import { ApplicationType } from '../../../shared/models/application-type.model';
import { ApplicationState } from '../../../shared/models/application-state.enum';
import { applicantType, ApplicantType } from '../../../shared/models/applicant-type.enum';
import { ApplicationsService } from '../../../shared/services/applications.service';
import { MunicipalitiesService } from '../../../shared/services/municipalities.service';
import { Application } from '../../../shared/models/application.model';
import { notRequiredEmail } from '../../../shared/validators/not-required-email.validator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppealReason } from '../../../shared/models/appeal-reason.model';

@Component({
    selector: 'app-application-create',
    templateUrl: './application-create.component.html',
    styles: []
})
export class ApplicationCreateComponent extends BaseComponent implements OnInit {

    public form: FormGroup;
    public applicationType: ApplicationType;
    public user: PortalUser = currentUser();
    public municipalitiesNomitive: Array<any> = [];
    public dpkHasDeferralOfBankLoanPaymentSelections: Array<any> = [];
    public showDPKDeferralOfBankLoanPaymentAdditionalInfo = false;
    public appealReasonSelections: Array<any> = [];
    public showAppealReasonAdditionalInfo = false;
    public appealReasonDescription = "";
    public appealReasons: AppealReason[];
    
    constructor(private router: Router,
        private route: ActivatedRoute,
        public applicationTypesService: ApplicationTypesService,
        public municipalitiesService: MunicipalitiesService,
        private applicationService: ApplicationsService,
        private dialogService: TdDialogService,
        private snackbar: MatSnackBar,
        private viewContainerRef: ViewContainerRef) {
        super();
    }

    ngOnInit() {
        var self = this;
        const typeId = this.route.snapshot.params['id'];
        this.municipalitiesNomitive = this.route.snapshot.data['municipalities'].map(m => {
            return { label: m.nameNomitive, value: m.id.toString() };
        });
        this.dpkHasDeferralOfBankLoanPaymentSelections.push({ label: 'Kreipiuosi dėl standartinių palūkanų kompensavimo priemonių', value: false });
        this.dpkHasDeferralOfBankLoanPaymentSelections.push({ label: 'Kreipiuosi dėl palūkanų kompensacijos ir turiu banko patvirtintą paskolos mokėjimo atidėjimą', value: true });
        this.applicationType = null;
        this.subscriptions.push(
            this.applicationTypesService.get(typeId).subscribe(applicationType => {
                this.applicationType = applicationType;
                if (this.applicationType.dpkDeferralOfBankLoanPaymentAttributeIsRequired == true) {
                    this.form.addControl('dpkHasDeferralOfBankLoanPayment', new FormControl(null));
                    this.onDPKBankLoandPaymentChanges();
                }
                if (this.applicationType.appealReasonIsRequired == true) {
                    this.applicationTypesService.getAppealReasons(typeId).subscribe((data: AppealReason[]) => {
                        self.appealReasons = data;
                        data.forEach(function (item) {
                            self.appealReasonSelections.push({ label: item.name, value: item.id });
                        });
                        self.form.addControl('appealReasonId', new FormControl(null));
                        self.onAppealResaonChanges();
                    })
                }
            })
        );

        this.form = new FormGroup({
            municipalityId: new FormControl(null, Validators.required),
            applicationTypeId: new FormControl(typeId, Validators.required),
            applicantCode: new FormControl({ value: this.user.applicantCode, disabled: true }, [Validators.required, Validators.maxLength(20)]),
            applicantName: new FormControl({ value: this.user.applicantName, disabled: true }, Validators.required),
            applicantType: new FormControl({ value: applicantType[this.user.applicantType], disabled: true }, Validators.required),
            applicantFirstAndLastName: new FormControl(this.user.userName, Validators.required),
            applicantPhone: new FormControl(null),
            applicantEmail: new FormControl(null, notRequiredEmail),
            applicantPosition: new FormControl(null),
            street: new FormControl(null, Validators.maxLength(100)),
            house: new FormControl(null, Validators.maxLength(10)),
            postCode: new FormControl(null, Validators.maxLength(5)),
            city: new FormControl(null, Validators.maxLength(100)),
            country: new FormControl('Lietuva', Validators.maxLength(100)),
            responsableFirstAndLastName: new FormControl(null, Validators.maxLength(100)),
            responsablePosition: new FormControl(null, Validators.maxLength(150)),
            responsablePhone: new FormControl(null, Validators.maxLength(20)),
            responsableEmail: new FormControl(null, notRequiredEmail),
            employeeFirstName: new FormControl(null, Validators.maxLength(20)),
            employeeLastName: new FormControl(null, Validators.maxLength(50)),
        });
        
        let vars = JSON.parse(localStorage.getItem('vars'));

        if (vars && vars.appData && vars.appData.length > 10) {
            let appData = JSON.parse(vars.appData);
            appData.applicationTypeId = typeId;

            this.form.patchValue(appData);
        }

    }

    onDPKBankLoandPaymentChanges(): void {
        this.form.get('dpkHasDeferralOfBankLoanPayment').valueChanges.subscribe(val => {
            if (val == 'true') {
                this.showDPKDeferralOfBankLoanPaymentAdditionalInfo = true;
            }
            if (val == 'false') {
                this.showDPKDeferralOfBankLoanPaymentAdditionalInfo = false;
            }
        });
    }

    onAppealResaonChanges(): void {
        this.form.get('appealReasonId').valueChanges.subscribe(val => {
            if (!isNaN(val)) {
                this.showAppealReasonAdditionalInfo = true;
                var appealDescription = this.appealReasons.find(function (item) {
                    return item.id == val;
                });
                this.appealReasonDescription = appealDescription.description;
            }
            if (isNaN(val)) {
                this.showAppealReasonAdditionalInfo = false;
                this.appealReasonDescription = "";
            }
        });
    }

    public save() {
        if (this.form.invalid) {
            this.snackbar.open('Nekorektiškai užpildyti formos laukai', null, { 'panelClass': 'bgc-red-400' });
            return;
        };
        let application: Application = this.form.value;
        application.applicationGeneralData = JSON.stringify(application);
      this.applicationService.create(application).subscribe(x => {
            let vars = JSON.parse(localStorage.getItem('vars'));
            if (vars && vars.appData == null) {
              vars.appData = application.applicationGeneralData;
              var newVars = JSON.stringify(vars);
              localStorage.setItem('vars', newVars);
            }
            this.router.navigate(['/portal', 'applications', x.id]);
        })
    }

    cancel(): void {
        this.dialogService.openConfirm({
            message: 'Ar tikrai norite atsisakyti paraiškos pildymo?',
            viewContainerRef: this.viewContainerRef,
            title: 'Patvirtinimas',
            acceptButton: 'Taip',
            cancelButton: 'Ne',
        }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
                this.router.navigate(['../../'], { relativeTo: this.route });
            }
        });
    }
}
